module.exports = __webpack_public_path__ + "static/media/external_link.fb844072.svg";